import { TableColumnProps } from 'components/table/table-component/table-component';

export const orgVulnerabilityReportTableStructure: TableColumnProps[] = [
  {
    id: 'name',
    title: 'Department',
    position: 'left',
  },
  // {
  //   id: 'email',
  //   title: 'Email',
  //   position: 'left',
  //   noFilters: true,
  // },
  {
    id: 'commit_count',
    title: 'Commits',
    position: 'left',
    noFilters: true,
  },
  {
    id: 'opened',
    title: 'PRs Opened',
    position: 'left',
    noFilters: true,
  },
  {
    id: 'commented',
    title: 'Commented',
    position: 'left',
    noFilters: true,
  },
  {
    id: 'changes_requested',
    title: 'Change Requested',
    position: 'left',
    noFilters: true,
  },
  {
    id: 'approved',
    title: 'Approved',
    position: 'left',
    noFilters: true,
  },
  {
    id: 'merged',
    title: 'PRs Merged',
    position: 'left',
    noFilters: true,
  },
];

export const PullsTableStructure: TableColumnProps[] = [
  {
    id: 'owner',
    title: 'Organization',
    // withSort: true,
    noFilters: true,
    position: 'left',
  },
  {
    id: 'repository',
    title: 'Repository',
    // withSort: true,
    noFilters: true,
    position: 'left',
  },
  {
    id: 'number',
    title: 'Number',
    // withSort: true,
    position: 'left',
  },
  {
    id: 'url',
    title: 'URL',
    position: 'left',
  },
  {
    id: 'title',
    title: 'Title',
    // withSort: true,
    noFilters: true,
    position: 'left',
  },
  {
    id: 'source_branch',
    title: 'Branch',
    // withSort: true,
    position: 'left',
  },
  {
    id: 'source',
    title: 'Source',
    // withSort: true,
    position: 'left',
  },
  {
    id: 'identity_login',
    title: 'Author',
    // withSort: true,
    position: 'left',
  },
];

export const CommitsTableStructure: TableColumnProps[] = [
  {
    id: 'owner',
    title: 'Organization',
    // withSort: true,
    noFilters: true,
    position: 'left',
  },
  {
    id: 'repository',
    title: 'Repository',
    // withSort: true,
    noFilters: true,
    position: 'left',
  },
  {
    id: 'author_name',
    title: 'Author',
    // withSort: true,
    position: 'left',
  },
  {
    id: 'sha',
    title: 'SHA',
    position: 'left',
  },
  {
    id: 'title',
    title: 'Title',
    // withSort: true,
    noFilters: true,
    position: 'left',
  },
  {
    id: 'branch',
    title: 'Branch',
    // withSort: true,
    position: 'left',
  },
  {
    id: 'source',
    title: 'Source',
    // withSort: true,
    position: 'left',
  },
];

export const OldTableStructure: TableColumnProps[] = [
  {
    id: 'description',
    title: 'Secret Type',
    withSort: true,
    position: 'left',
  },
  {
    id: 'organization',
    title: 'Organization',
    withSort: true,
    noFilters: true,
    position: 'left',
  },
  {
    id: 'repository',
    title: 'Repository',
    withSort: true,
    noFilters: true,
    position: 'left',
  },
  {
    id: 'commit',
    title: 'SHA',
    position: 'left',
  },
  {
    id: 'user_login',
    title: 'User ID',
    withSort: true,
    noFilters: true,
    position: 'left',
  },
  {
    id: 'email',
    title: 'Email',
    withSort: true,
    position: 'left',
  },
  {
    id: 'created',
    title: 'Commit Date',
    withSort: true,
    noFilters: true,
    position: 'left',
    isDate: true,
  },
  {
    id: 'file',
    title: 'File',
    position: 'left',
  },
  {
    id: 'verified',
    title: 'Verified',
    withSort: true,
    position: 'left',
  },
];

export interface GraphActivityTypes<T> {
  key: keyof T;
  name: string;
  color: string;
}
